var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    fill: "#55676E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2656 65.6992V45.5625H57.0156V65.6992C57.0156 67.5742 56.6315 69.1562 55.8633 70.4453C55.0951 71.7344 54.0339 72.7174 52.6797 73.3945C51.3385 74.0586 49.7956 74.3906 48.0508 74.3906C46.306 74.3906 44.7565 74.0911 43.4023 73.4922C42.0482 72.8932 40.987 71.9818 40.2188 70.7578C39.4505 69.5339 39.0664 67.9909 39.0664 66.1289H42.8359C42.8359 67.3268 43.0573 68.3099 43.5 69.0781C43.9427 69.8464 44.5547 70.4128 45.3359 70.7773C46.1302 71.1419 47.0352 71.3242 48.0508 71.3242C49.0404 71.3242 49.9258 71.1159 50.707 70.6992C51.5013 70.2695 52.1263 69.638 52.582 68.8047C53.0378 67.9583 53.2656 66.9232 53.2656 65.6992ZM73.9102 45.5625V74H70.1992V45.5625H73.9102ZM83.0508 45.5625V48.6484H61.0781V45.5625H83.0508Z",
    fill: "#36454B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconExample);
export default __webpack_public_path__ + "static/media/user-icon-example.45cc0afdfd038e1b904f0732ac358be0.svg";
export { ForwardRef as ReactComponent };